export const FSAR_HEADER_SIZE = 0x20
export const FSAR_TOC_ENTRY_SIZE = 0x120
